import {PaginationInfo} from './pagination-info';
import {AdditionalInfo} from './additional-info';

export class PagedResponse<T> {
  public additionalInfo: AdditionalInfo;
  public paginationInfo: PaginationInfo;
  public results: T[];
}

